// Get the hostname from the request
export function getDomainUrl(request: Request) {
  const host =
    request.headers.get('x-orig-host') ??
    request.headers.get('host') ??
    new URL(request.url).host
  const protocol = request.headers.get('X-Forwarded-Proto') ?? 'http'
  return `${protocol}://${host}`
}

// Checks if the environment is development - useful for conditionally showing sections for testing
export const isDevelopment = process.env.NODE_ENV === 'development'

// Get the last part of a url path
export function getLastUrlSegment(url: string): string {
  return url?.split('/').filter(Boolean).pop() || ''
}

export function getErrorMessage(error: unknown) {
  if (typeof error === 'string') return error
  if (
    error &&
    typeof error === 'object' &&
    'message' in error &&
    typeof error.message === 'string'
  ) {
    return error.message
  }
  console.error('Unable to get error message for error', error)
  return 'Unknown Error'
}

// Checks if a value contains a number - this is used on any number including string + number combinations
// eg. '1234', '1234.56', '1234 abc', 'abc 1234', 'data 1', 1234, 1234.56

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function containsNumber(value: any): boolean {
  if (typeof value === 'string') {
    const hasNumber = /\d/.test(value)
    // console.debug('Checking string:', value, '=>', hasNumber)
    return hasNumber
  }

  if (typeof value === 'number') {
    // console.debug('Checking number:', value, '=> true')
    return true
  }

  if (Array.isArray(value)) {
    // console.debug('Checking array:', value)
    return value.some(item => containsNumber(item))
  }

  if (typeof value === 'object' && value !== null) {
    // console.debug('Checking object:', value)

    if ('value' in value) {
      // console.debug('Found "value" property in object:', value.value)
      return containsNumber(value.value)
    }

    return Object.values(value).some(item => containsNumber(item))
  }

  return false
}

// Checks if a value contains a number only
// eg. '1234', '1234.56',

// eslint-disable-next-line @typescript-eslint/no-explicit-any
// export function containsNumber(value: any): boolean {
//   if (typeof value === 'number') return Number.isInteger(value)

//   if (typeof value === 'string') return /^\d+$/.test(value)

//   if (Array.isArray(value)) {
//     return value.length === 1 && containsNumber(value[0])
//   }

//   if (typeof value === 'object' && value !== null) {
//     return containsNumber(value.value)
//   }

//   return false
// }

// Checks if a value is a number and formats it to a string with commas
// eg. 1234 => '1,234', 1234.56 => '1,234.56', '1234' => '1,234', '1234.56' => '1,234.56'
export function numberWithCommas(x: number | string): string {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const colourMap: Record<string, string> = {
  chartreuse: '#d7f777',
  'ink-blue': '#0e1647',
  'mid-blue': '#1d4cf2',
  'light-blue': '#82daf4',
  'light-pink': '#f5b6dc',
  'light-purple': '#a8a4ee',
  'light-orange': '#ffc77a',
  'light-aqua': '#7ae3ca',
  'light-grey': '#f1f1f4',
  white: '#ffffff'
}

export function parseValidDate(dateStr?: string): Date | undefined {
  if (!dateStr) return undefined
  const date = new Date(dateStr)
  return isNaN(date.getTime()) ? undefined : date
}
